import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import { ModalGeneric } from "components/modal/ModalGeneric";
import Pagination from "components/Pagination/Pagination";
import { SearchAdvancedModule } from "components/SearchSimpleAdvanced/SearchAdvancedModule";
import TableOrder from "components/Tables/TableOrder";
import { ExportDetail } from "pages/CustomsClearance/Adjunto/ExportDetail";
import { HeaderSearch } from "styled/SectionContainer.styled";
import { Title } from "styled/Title";
import { useModal } from "hooks/useModal";
import { useForm } from "hooks/useForm";
import {
  theadContainerTreasury,
  TitleWehithing,
  trasuryWeigthNodeSelectList,
  trasuryWeigthSelectNodeList
} from "../ArrayList/ArrayList";
import environment from "constants/apiConst";
import { useSelector } from "react-redux";
import TbodyWeigh from "../Tables/TbodyWeigh";
import TBodyContainers from "../Tables/TbodyContainers";
import TreasuryCrudContex from "context/TreasuryContex";
import { IconGeneric } from "styled/Icons.styled";
import { GrDocumentText } from "react-icons/gr";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import FormsSearchWeigh from "../Forms/FormsSearchWeigh";
import { useDispatch } from "react-redux";
import { clearSearch, getSearch, setSearch } from "redux/actions/searchActions";
import { ModalExportAdvance } from "components/ExportByColumn/ExportAdvance";
import { useSearchUrl } from "hooks/useSearchUrl";
import { useWeighIns, useWeighInsSearch } from "hooks/useWeighIns";

const Weigh = () => {
  const { state, clearParamsSearch } = useSearchUrl({ getParams: ["search", "valueQualified"], nestedProp: "searchSimple" });
  const { cleanState } = useSearchUrl({ getParams: ["order", "consecutive", "vehiclePlate", "completeness", "startDate", "endDate", "shedule", "formType", "formNumber", "completen", "operation", "shedules"], nestedProp: "searchAdvance" });

  const [page, setPage] = useState(1);
  const [pageSearch, setPageSearch] = useState(1);
  const [isOpenSearch, onOpenSearch, onCloseSearch] = useModal();
  const [isOpenExport, onOpenExport, onCloseExport] = useModal();
  const [changeViewSearch, setChangeViewSearch] = useState(false);
  const [searcheAdvanced, setSearchAdvanced] = useState(cleanState);
  
  const token = useSelector((state) => state.auth.dataUser.token);
  const { user_rol, admin } = useSelector((state) => state.auth.dataUser);
  const [allAccess, setAllAccess] = useState(false);
  const [myPermission, setmyPermission] = useState(null);
  const [openAlert] = AlertErrorAlert();

  const [values, handleInputChange, reset, setValues] = useForm({
    searchInformacion: state?.search,
    valueQualified: state?.valueQualified,
  });
  const { searchInformacion, valueQualified } = values;

  // React Query hooks
  const { data: weighInsData, isLoading } = useWeighIns(token, page, !changeViewSearch);
  
  // Preparar datos de búsqueda con useMemo para estabilizar
  const searchData = useMemo(() => ({
    ...(valueQualified && valueQualified?.value && {
      qualifiedUser_id: valueQualified?.value
    }),
    ...(searchInformacion && { search: searchInformacion }),
    ...searcheAdvanced
  }), [valueQualified, searchInformacion, searcheAdvanced]);
  
  // Hook de búsqueda con useQuery
  const { 
    data: searchData_result, 
    isLoading: isSearchLoading, 
    error: searchError
  } = useWeighInsSearch(token, searchData, pageSearch, changeViewSearch && Object.keys(searchData).length > 0);
  
  // Ref para funciones de dispatch estables
  const dispatchSearchRef = useRef();
  const dispatchClearSearchRef = useRef();
  const lastSearchDataRef = useRef(null);
  const shouldResetPageRef = useRef(false);
  const lastQualifiedUserIdRef = useRef(null);
  const {
    isOpenContainers,
    onOpenContainer,
    onCloseModal,
    dataContainer,
    isOpenForms,
    onOpenForms,
    dataForms,
    exportColumnBy,
    setRequestExport
  } = useContext(TreasuryCrudContex);

  const backSearch = () => {
    console.log('backSearch');
    clearParamsSearch({ searchArray: ["searchSimple", "searchAdvance"] });
    reset();
    setSearchAdvanced({});
    // setValueQuialified(null);
    setChangeViewSearch(false);
  };

  const search = useSelector(getSearch);

  const handleSubmit = (data, formulario) => {
    const info = {
      fields: formulario,
      data: {
        ...data,
        ...(data?.formType && { formType: data?.formType?.value }),
        ...(data?.order && { order: data?.order?.value }),
        ...(data?.userManagment && { userManagment: data?.userManagment?.value }),
        ...search,
      },
    };
    // console.log(info);


    exportColumnBy(info, onCloseExport);
  };


  useEffect(() => {
    if (admin === 1) {
      setAllAccess(true);
    } else if (!allAccess) {
      const newArray = [];
      user_rol?.modules?.map((item) => {
        return item.permission.map((e) => newArray.push(e.name_permission));
      });
      setmyPermission(newArray);
    }
  }, [user_rol, allAccess, admin]);

  const dispatchRedux = useDispatch();
  
  // Configurar funciones de dispatch en refs para evitar bucles
  dispatchSearchRef.current = (data) => {
    dispatchRedux(setSearch(data));
  };
  
  dispatchClearSearchRef.current = () => {
    dispatchRedux(clearSearch());
  };
  

  // useEffect simplificado para manejar cambios de búsqueda
  useEffect(() => {
    const searchDataString = JSON.stringify(searchData);
    const lastSearchDataString = lastSearchDataRef.current ? JSON.stringify(lastSearchDataRef.current) : null;
    
    // Solo ejecutar si los datos realmente han cambiado
    if (searchDataString !== lastSearchDataString) {
      lastSearchDataRef.current = searchData;
      
      // Si hay datos de búsqueda, activar modo búsqueda
      if (Object.keys(searchData).length > 0) {
        setChangeViewSearch(true);
        shouldResetPageRef.current = true; // Marcar para resetear página
        dispatchSearchRef.current(searchData);
        onCloseSearch();
      } else {
        // Si no hay datos de búsqueda, limpiar modo búsqueda
        setChangeViewSearch(false);
        shouldResetPageRef.current = true; // Marcar para resetear página
        dispatchClearSearchRef.current();
      }
    }
  }, [searchData, onCloseSearch]);

  // useEffect para resetear página cuando cambien los parámetros de búsqueda
  useEffect(() => {
    if (shouldResetPageRef.current && changeViewSearch) {
      setPageSearch(1);
      shouldResetPageRef.current = false;
    }
  }, [changeViewSearch]);

  // useEffect específico para detectar cambios en usuario calificado
  useEffect(() => {
    const currentQualifiedUserId = valueQualified?.value || null;
    const lastQualifiedUserId = lastQualifiedUserIdRef.current;
    
    // Si el usuario calificado ha cambiado y estamos en modo búsqueda, resetear página
    if (currentQualifiedUserId !== lastQualifiedUserId && changeViewSearch) {
      setPageSearch(1);
    }
    
    // Actualizar el ref con el valor actual
    lastQualifiedUserIdRef.current = currentQualifiedUserId;
  }, [valueQualified, changeViewSearch]);

  // useEffect para manejar errores de búsqueda
  useEffect(() => {
    if (searchError) {
      if (searchError.message === "Acceso no autorizado.") {
        reset();
        setSearchAdvanced({});
        setChangeViewSearch(false);
        openAlert(searchError.message, "error");
      } else {
        console.error('Error en búsqueda:', searchError);
      }
    }
  }, [searchError, reset, openAlert]);


  useEffect(() => {
    setRequestExport(environment.TREASURY_EXPORT_MODULE_WEIGTH);
  }, [setRequestExport]);

  return (
    <>
      <Title style={{ marginTop: 30 }}>Pesajes</Title>
      <ModalGeneric
        isOpen={isOpenSearch}
        onClose={onCloseSearch}
        title={"Búsqueda avanzada"}
      >
        <FormsSearchWeigh
          onClose={onCloseSearch}
          setSearchAdvanced={setSearchAdvanced}
        />
      </ModalGeneric>

      <ModalExportAdvance
        isOpen={isOpenExport}
        onOpen={onOpenExport}
        onClose={onCloseExport}
        title={"Exportar documento"}
        nodeList={trasuryWeigthNodeSelectList}
        selectNodeList={trasuryWeigthSelectNodeList}
        handleSubmit={handleSubmit}
        dafaulActive={[
          "passForm_number",
          "weighings.id",
          "treasury_charges.value",
          "value"
        ]}
      />

      {/* <ModalGeneric
        isOpen={isOpenExport}
        onOpen={onOpenExport}
        onClose={onCloseExport}
        title={"Exportar documento"}
      // size={"4xl"}
      >
        <ExporByColumn
          onClose={onCloseExport}
          ListLeft={arrayLeftTreasuryWeigth}
          listRight={arrayRigthTreasuryWeigth}
          dafaulActive={[
            "passForm_number",
            "weighings.id",
            "treasury_charges.value",
            "value"
          ]}
          existingOrder={true}
        />
      </ModalGeneric> */}

      <div className="container p-4">
        <SearchAdvancedModule
          handleInputChange={handleInputChange}
          values={values}
          onOpenSearch={onOpenSearch}
          changeViewSearch={changeViewSearch}
          backSearch={backSearch}
          allAccess={allAccess}
          myPermission={myPermission}
          setValues={setValues}
        />
        <ExportDetail onOpen={onOpenExport} />
      </div>

      <ModalGeneric
        isOpen={isOpenContainers}
        onOpen={onOpenContainer}
        onClose={onCloseModal}
        title="Ver contenedores"
      >
        <TableOrder
          thead={theadContainerTreasury}
          data={dataContainer || []}
          setData={() => {}} // React Query maneja los datos
          loading={isLoading}
          tbodyData={TBodyContainers}
        />
      </ModalGeneric>

      <ModalGeneric
        isOpen={isOpenForms}
        onOpen={onOpenForms}
        onClose={onCloseModal}
        title="Formulario asociados al pase"
        size={"sm"}
      >
        {dataForms &&
          dataForms.map((item, index) => (
            <div className="p-2">
              <IconGeneric as={GrDocumentText} />
              <span key={index}>Formulario número: {item?.code_entryForm}</span>
              <br />
            </div>
          ))}
      </ModalGeneric>

      <HeaderSearch>
        {changeViewSearch
          ? (
            <div className="px-5">
              {searchData_result?.total && searchData_result.total !== null && (
                <div className="d-flex">
                  <Title>Valor Total: {searchData_result.total}</Title>
                </div>
              )}
              <div>
                <TableOrder
                  thead={TitleWehithing}
                  data={searchData_result?.data || []}
                  setData={() => {}} // React Query maneja los datos
                  loading={isSearchLoading}
                  tbodyData={TbodyWeigh}
                />

                <Pagination
                  page={pageSearch}
                  setPage={setPageSearch}
                  maxPage={searchData_result?.lastPage || 1}
                  loading={isSearchLoading}
                />
              </div>
            </div>
          )
          : (
            <div>
              <TableOrder
                thead={TitleWehithing}
                data={weighInsData?.data || []}
                setData={() => {}} // React Query maneja los datos
                loading={isLoading}
                tbodyData={TbodyWeigh}
              />
              <Pagination
                page={page}
                setPage={setPage}
                maxPage={weighInsData?.lastPage || 1}
                loading={isLoading}
              />
            </div>
          )}
      </HeaderSearch>
    </>
  );
};

export default Weigh;
